(function(){
  document.querySelectorAll('[data-bwl]').forEach(function(root){
    var form = root.querySelector('[data-facets]');
    var sort = root.querySelector('[data-sort]');
    var desktop = window.matchMedia('(min-width: 1101px)');
    function go(){
      if (!form) {
        var u = new URL(window.location.href);
        if (sort) u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
        return;
      }
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function(v, k){ if (v !== '') params.append(k, v); });
      window.location.href = form.getAttribute('action') + '?' + params.toString();
    }
    if (form) {
      form.addEventListener('change', function(e){ if (e.target.type === 'number') return; go(); });
      form.addEventListener('submit', function(e){ e.preventDefault(); go(); });
      var dets = form.querySelectorAll('[data-filter]');
      dets.forEach(function(d){
        d.addEventListener('toggle', function(){
          if (d.open && desktop.matches) dets.forEach(function(o){ if (o !== d) o.open = false; });
        });
      });
      document.addEventListener('click', function(e){
        if (!desktop.matches) return;
        dets.forEach(function(d){ if (d.open && !d.contains(e.target)) d.open = false; });
      });
      form.querySelectorAll('[data-more]').forEach(function(b){
        b.addEventListener('click', function(){
          b.parentElement.querySelectorAll('.is-more').forEach(function(li){ li.hidden = false; });
          b.remove();
        });
      });
    }
    if (sort) {
      sort.addEventListener('change', function(){
        var h = form && form.querySelector('[data-sort-hidden]');
        if (h) h.value = sort.value;
        go();
      });
    }
    var aside = root.querySelector('[data-aside]');
    var open = root.querySelector('[data-filter-open]');
    var close = root.querySelector('[data-filter-close]');
    function shut(){ if (!aside) return; aside.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    if (aside && open) open.addEventListener('click', function(){ aside.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; var c = aside.querySelector('[data-filter-close]'); c && c.focus(); });
    if (close) close.addEventListener('click', shut);
    document.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      shut();
      if (form) form.querySelectorAll('[data-filter][open]').forEach(function(d){ d.open = false; });
    });
  });

  document.querySelectorAll('[data-bwc]').forEach(function(form){
    form.querySelectorAll('[data-step]').forEach(function(b){
      b.addEventListener('click', function(){
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(0, (+input.value || 0) + (+b.dataset.step));
        form.submit();
      });
    });
    form.querySelectorAll('.bwc-qty input').forEach(function(i){ i.addEventListener('change', function(){ form.submit(); }); });
  });
})();
